export default "__VITE_ASSET__Cegq2Sqs__"